import React from 'react';
import { format, parseISO } from 'date-fns';
import { Calendar, Clock, Users, X } from 'lucide-react';
import { formatTimeWindow } from '../../utils/timeWindows';
import Badge from '../ui/Badge';

const TripScheduleDetailHeader = ({
  trip,
  statusBadgeType,
  statusLabel,
  joinDeadlineLabel,
  onClose,
}) => {

  const formatTravelDate = (dateString) => {
    try {
      return format(parseISO(dateString), 'MMM d, yyyy');
    } catch {
      try {
        return format(new Date(dateString), 'MMM d, yyyy');
      } catch {
        return dateString;
      }
    }
  };

  const timeLabel = formatTimeWindow(trip.time_window_start, trip.time_window_end);
  const showUsersIcon = statusBadgeType === 'warning';

  return (
    <div className="p-5 border-b border-[#E8DED1]/80">
      <div className="flex items-start justify-between gap-3 mb-3">
        <Badge type={statusBadgeType} className="inline-flex items-center gap-1">
          {showUsersIcon && <Users size={12} className="shrink-0" />}
          {statusLabel}
        </Badge>
        <div className="flex items-center gap-2 shrink-0">
          {joinDeadlineLabel && (
            <span
              className={`text-xs font-semibold ${
                joinDeadlineLabel === 'Join closed'
                  ? 'text-stone-500'
                  : 'text-[#A44432]'
              }`}
            >
              {joinDeadlineLabel}
            </span>
          )}
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg text-stone-400 hover:text-stone-600 hover:bg-stone-100 lg:hidden"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#2D1E17] leading-tight">
        {trip.pickup_location}
        <span className="text-[#A44432] mx-1.5">→</span>
        {trip.dropoff_location}
      </h2>
      <p className="text-sm text-stone-500 mt-1">Shared transfer</p>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-4 text-sm text-[#2D1E17]">
        <span className="inline-flex items-center gap-1.5">
          <Calendar size={14} className="text-[#A44432] shrink-0" />
          {formatTravelDate(trip.travel_date)}
        </span>
        <span className="hidden sm:inline text-stone-300" aria-hidden>
          |
        </span>
        <span className="inline-flex items-center gap-1.5 min-w-0">
          <Clock size={14} className="text-[#A44432] shrink-0" />
          <span className="truncate">{timeLabel.replace(' - ', ' – ')}</span>
        </span>
      </div>
    </div>
  );
};

export default TripScheduleDetailHeader;
